import React, { useEffect } from 'react';
import { useState } from 'react';
import PageLayout from "../components/page-layout";
import UploadsTable from '../components/uploads-table';
import { useGetAllUploadedFiles } from '../services/support';

export default function Uploads() {

    const getUplaods = useGetAllUploadedFiles()
    const [files, setFiles] = useState([])
    useEffect(() => {
        getUplaods().then(setFiles)
    },[])
    return (
        <PageLayout pageTitle="فایل‌‌های اپلود‌شده">
            <UploadsTable files={files}/>
        </PageLayout>
    );
}

